const THEME_ID = "$$material";
export {
  THEME_ID as default
};
//# sourceMappingURL=identifier.es.js.map
